import { useEffect, useState } from 'react';

function Toast({ id, type, message, onClose }) {
  useEffect(() => {
    const t = setTimeout(() => onClose(id), 5000);
    return () => clearTimeout(t);
  }, [id, onClose]);

  const bgClass =
    type === 'error'
      ? 'danger'
      : type === 'success'
        ? 'success'
        : type === 'warning'
          ? 'warning'
          : 'primary';
  const cls = `toast show align-items-center text-bg-${bgClass} border-0`;
  return (
    <div
      className={cls}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{ minWidth: 240 }}
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          onClick={() => onClose(id)}
        ></button>
      </div>
    </div>
  );
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    function handler(e) {
      const { type, message } = e.detail || {};
      const id = Date.now() + Math.random();
      setToasts((t) => [...t, { id, type, message }]);
    }

    window.addEventListener('yubu-toast', handler);
    return () => window.removeEventListener('yubu-toast', handler);
  }, []);

  const remove = (id) => setToasts((t) => t.filter((x) => x.id !== id));

  if (toasts.length === 0) return null;

  return (
    <div style={{ position: 'fixed', right: 16, top: 16, zIndex: 9999 }}>
      {toasts.map((t) => (
        <div key={t.id} className="mb-2">
          <Toast {...t} onClose={remove} />
        </div>
      ))}
    </div>
  );
}
